import { render } from "solid-js/web";
import "../../css/styles.css";
import "./fonts.css";
import "./solid.css";
import { App } from "./App";
import { createAuthModule, createBrowserStorage } from "./features/auth/auth";
import { createFetchHttp } from "./lib/http";

const root = document.getElementById("root");
if (!root) throw new Error("Solid root element is missing");

const http = createFetchHttp();
const auth = createAuthModule(http, createBrowserStorage(localStorage));

render(() => <App auth={auth} http={http} />, root);
